import { Component, computed, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';
import { SportType } from '../../../models/sport.model';
import { UnitType } from '../../../models/unit.model';
import { PacePipe } from '../../../pipes/pace-pipe';

@Component({
  selector: 'li[app-pace-data-block-item]',
  imports: [Icon, DataItemTemplate],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon [size]="iconSize()" class="icon" icon="speed" />
      @if (!isFlip()) {
        <div [class]="'unit ' + size()">
          <p class="name">{{ distanceUnit() }}</p>
        </div>
        <p class="value">{{ value() }}</p>
      } @else {
        <span>
          <p class="name">{{ distanceUnit() }}</p>
          <p class="average-name">moy.</p>
        </span>
        <p class="value">
          <span class="value">{{ value() }}</span>
        </p>
      }
    </app-data-item-template>
  `,
  styleUrl: './pace-data-block-item.scss',
})
export class PaceDataBlockItem extends DataItemTemplate {
  private readonly pacePipe: PacePipe = new PacePipe();
  private readonly sport: Signal<SportType> = computed(
    () => this.webSocketService.contentInformation()?.sport || 'cycling',
  );
  private readonly unit: Signal<UnitType> = computed(
    () => (localStorage.getItem('unit') as UnitType | undefined) || 'metric',
  );
  private readonly speed: Signal<number> = computed(
    () => this.webSocketService.broadcastData()?.data.speed || 0,
  );
  private readonly averageSpeed: Signal<number> = computed(
    () => this.webSocketService.broadcastData()?.data.avgSpeed!,
  );

  value: Signal<string> = computed(() =>
    this.pacePipe.transform(
      !this.isFlip() ? this.speed() : this.averageSpeed(),
      this.sport(),
      this.unit(),
      'value',
    ),
  );
  distanceUnit: Signal<string> = computed(() =>
    this.pacePipe.transform(this.speed(), this.sport(), this.unit(), 'unit'),
  );
}
